import i18n from 'simple-react-i18n'
import { isNil, last, uniq } from 'lodash'
import { grey } from '../../../utils/constants/ColorTheme'
import { MEASURE_COTE } from '../../../piezometry/constants/PiezometryConstants'
import { HYDRO_TYPEID } from '../../../hydrometry/constants/HydrometryConstants'
import { RETURN_PERIOD_BANDS } from '../../../import/constants/IndicatorsConstants'

const CHRONIC_TYPE = -1

const RETURN_PERIOD_MODE = 'RETURN_PERIOD_MODE'

const RETURN_PERIOD_BOUNDS = uniq(RETURN_PERIOD_BANDS.map(({ bound }) => `${bound}_SIMPLE`))

const getPiezoReturnPeriodInputs = (stationId, startEnveloppe, endEnveloppe, displayCote = MEASURE_COTE.DEPTH) => RETURN_PERIOD_BOUNDS.map(groupFunc => ({
    stationId,
    dataType: CHRONIC_TYPE,
    groupFunc,
    displayCote,
    validOnly: true,
    chartMode: true,
    startEnveloppe,
    endEnveloppe,
}))

const getHydroReturnPeriodInputs = (stationId, startEnveloppe, endEnveloppe) => RETURN_PERIOD_BOUNDS.map(groupFunc => ({
    stationId,
    dataType: HYDRO_TYPEID.HEIGHT,
    groupFunc,
    validOnly: true,
    chartMode: true,
    startEnveloppe,
    endEnveloppe,
}))

const boundGroupFunc = bound => `${bound}_SIMPLE`

const getCurveMeasures = (curves, bound) => curves.find(curve => curve.groupFunc === boundGroupFunc(bound))?.measures ?? []

const getBoundValue = (curves, bound, date) => last(getCurveMeasures(curves, bound).filter(m => m.date <= date))?.value

const isWetterThan = (value, bound, wetIsLow) => wetIsLow ? value < bound : value > bound

const getReturnPeriodBand = (curves, date, value, wetIsLow) => {
    if (isNil(value) || !curves.length) {
        return undefined
    }
    const bounds = RETURN_PERIOD_BANDS.map(({ bound }) => getBoundValue(curves, bound, date))
    if (bounds.some((bound, index) => index > 0 && isNil(bound))) {
        return undefined
    }
    const index = bounds.findIndex((bound, idx) => idx > 0 && isWetterThan(value, bound, wetIsLow))
    return index === -1 ? last(RETURN_PERIOD_BANDS) : RETURN_PERIOD_BANDS[index - 1]
}

const getReturnPeriodSeries = (curves, gridIndex, wetIsLow) => RETURN_PERIOD_BANDS.flatMap(band => {
    const measures = getCurveMeasures(curves, band.bound)
    if (!measures.length) {
        return []
    }
    return [{
        name: i18n[band.code],
        type: 'line',
        data: measures.map(({ date, value }) => ({ value: [date, value], isReturnPeriod: true })),
        showSymbol: false,
        silent: true,
        connectNulls: true,
        color: band.color,
        lineStyle: band.dashed ? { color: grey, type: 'dashed', width: 1 } : { opacity: 0 },
        areaStyle: { color: band.color, origin: !!band.above === !!wetIsLow ? 'start' : 'end', opacity: 1 },
        z: -1,
        xAxisIndex: gridIndex,
        yAxisIndex: gridIndex,
        tooltip: { show: false },
    }]
})

const isPiezoWetLow = displayCote => displayCote === MEASURE_COTE.DEPTH

export {
    RETURN_PERIOD_MODE,
    isPiezoWetLow,
    getPiezoReturnPeriodInputs,
    getHydroReturnPeriodInputs,
    getReturnPeriodBand,
    getReturnPeriodSeries,
}
